import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import type {
    SessionUser as SessionUserFragment,
    LeadStagesEdge as LeadStagesEdgeFragment,
    Lead_stageset,
} from 'nutshell-graphql-types';

import styles from './stage-guidance.module.css';

type Props = {
    user: SessionUserFragment | null | undefined;
    stageset: Lead_stageset;
    leadStageEdge: LeadStagesEdgeFragment;
};

export class StageGuidance extends React.PureComponent<Props> {
    render() {
        const {name, description} = this.props.leadStageEdge.node;

        if (description) {
            return (
                <div className={styles['stage-guidance']}>
                    <h4>Guidance</h4>
                    {description}
                </div>
            );
        } else if (this.props.user && this.props.user.permissions.canAccessSetup) {
            return <StageGuidanceEmptyState stageName={name} stageset={this.props.stageset} />;
        } else if (!this.props.leadStageEdge.goalConditions.length) {
            return (
                <div className={styles['stage-guidance-empty-non-admin']}>
                    Guidance has not been set for {name}
                </div>
            );
        }

        return null;
    }
}

type StageGuidanceEmptyStateProps = {
    stageset: Lead_stageset;
    stageName: string;
};

// These styles are influenced by _big-placeholder.less, so purposefully
// leaving classNames here, until we want to make a bigger lift
// to reove that.
function StageGuidanceEmptyState(props: StageGuidanceEmptyStateProps) {
    return (
        <div className='goals-guidance state-empty'>
            <div className='big-empty-placeholder'>
                <div className='icon' />
                <div className='title'>Share guidance with your team</div>
                <div className='description'>
                    Let your team know how they can be successful for every lead. Provide guidance
                    and tips at each stage of your sales process.
                </div>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} to={`/setup/sales-automation/${props.stageset.id}`}>
                    Add guidance for your {props.stageName} stage
                </Link>
            </div>
        </div>
    );
}
